<template>
    <div id="customer_discount" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="customerDiscount" v-if="$route.params.id > 0" >Update Discount</span>
                    <span class="page-title" id="customerDiscount"  v-else>Add Discount</span>

                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goPreviousPath" >
                        <i class="fp-back"> </i>  Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content discount-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="DiscountForm">
                                <div class="form-row row-cols-md-4 row-cols-1">

                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{ name_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Type:</label>
                                        <v-select v-model="type" name="type" placeholder="Select Type."
                                                label="text"
                                                :options="typeArr">
                                        </v-select>
                                        <div class="field-error">{{ type_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label v-if="type != ''" class="control-label require" for="code">Discount:</label>

                                        <input v-if="type.value == 'fixed'" type="text" class="form-control" v-model="discount" id="discount"
                                        @keypress="isAmountCheck($event, true, 99999999)"
                                        @blur="discount = leaveFocus($event)"
                                        @focus="discount = enterVal($event)"
                                        placeholder="Enter Discount" name="discount">

                                        <input v-if="type.value == 'percentage'" type="text" class="form-control" v-model="discount" id="discount"
                                        placeholder="Enter Discount" name="discount" @keypress="isAmountCheck($event, true, 99.99)" max="99.99">
                                        <div class="field-error">{{ discount_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>

                                <div class="btn-groups1 text-right mt-2 mb-3">
                                    <button type="submit" id="createDiscountBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateCustomerDiscount" >
                                        <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createDiscountBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateCustomerDiscount" >
                                        <i class="fp-save"> </i>  Save
                                    </button>
                                    <!-- <button type="submit" id="createAndContinueDiscountBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateCustomerDiscount(flag='Save and Continue')" >
                                        <i class="fp-save-continue"> </i>  Save and Continue
                                    </button> -->
                                    <button type="submit" id="cancelDiscountBtn" class="btn btn-tertiary" v-on:click.prevent="BackHeaderList">
                                        <i class="fp-close"> </i>  Cancel
                                    </button>

                                    <!-- <button type="submit" id="createDiscountBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="toggleList">
                                        <i class="fp-reload"> </i>  {{buttonText}}
                                    </button> -->
                                </div>
                            </form>
                            <!-- <template v-if="loadselectedList">
                                <card-rates-customer-list :customerVal="'cardRateCustomerList'" ></card-rates-customer-list>
                                <p>&nbsp;</p>
                            </template> -->
                            <template>
                                <data-table-filter-config :moduleName="'discountCustomerList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                                    <div class="field-error">{{customer_error_msg}}</div>
                                    <section class="bg-white data-table">
                                            <custom-pagination
                                                :page-changed="onPageChange"
                                                :per-page-changed="onPerPageChange" :moduleName="'CustomerList'" :position="'top'">
                                            </custom-pagination>
                                            <vue-good-table
                                                ref="listDiscountCustomerTable"
                                                mode="remote"
                                                title="Customer"
                                                @on-page-change="onPageChange"
                                                @on-selected-rows-change="selectionChanged"
                                                @on-column-filter="onColumnFilter"
                                                @on-per-page-change="onPerPageChange"
                                                @on-sort-change="onSortChange"
                                                @on-select-all="onSelectAll"
                                                @on-row-click="onRowClick"
                                                :totalRows="totalRecords"
                                                :columns="userColumns"
                                                :rows="rows"
                                                :pagination-options="{
                                                    enabled: false,
                                                    setCurrentPage:listCurrentPage,
                                                    perPage: perPage,
                                                }"
                                                :select-options="{
                                                enabled: true,
                                                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                                                selectionInfoClass: 'custom-class',
                                                selectionText: 'rows selected',
                                                clearSelectionText: 'clear',
                                                }"
                                                :search-options="{
                                                enabled: false,
                                                }">

                                            </vue-good-table>

                                            <custom-pagination
                                                :page-changed="onPageChange"
                                                :per-page-changed="onPerPageChange"
                                                >
                                            </custom-pagination>
                                    </section>
                            </template>
                            <!-- if map type is multiple then button not display so displayed it -->
                            <div style="clear:both"></div>


                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

import EventBus from "././event-bus";


import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
  name: "CustomerDiscountCreate",
  components: {
    
    
    customAssetPagination: () => import('@/components/layout/CustomPagination'),
    cardRatesCustomerList: () => import('@/components/DiscountCustomerList'),
    
  },
  metaInfo() {
        return {
            title: (this.$route.params.id > 0)? "Update Customer Discount | " +process.env.COPYRIGHT_NAME : "Create Customer Discount | " +process.env.COPYRIGHT_NAME
        }
  },
  mixins:[commonMixins,contractMixins,dataTableMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    customer_id: null,
    customerArr: [],
    typeArr: [
        {
            text: "Percentage",
            value: "percentage"
        },
        {
            text: "Fixed",
            value: "fixed"
        },
    ],
    type_error_msg:'',
    name:'',
    type:'',
    loading:false,
    discount_error_msg:'',
    name_error_msg:'',
    rows: [],
    totalRecords: 0,
    userColumns:[],
    discount:'',
    columns: [
            {
                label: 'Code',
                field: 'code',
                filterable: true,
                fpFieldType:"text",
                width:'140px',
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterFn: this.onColumnFilter,
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Name',
                field: 'name',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Email',
                field: 'email',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Email", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Phone',
                field: 'work_phone',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Phone", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'City',
                field: 'city',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "City", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'State',
                field: 'state',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "State", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Stage',
                field: 'stage',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Potential', 'Account Pending', 'Credit Denied', 'New', 'Existing'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Created At',
                field: 'created_at',
                fpFieldType:"date",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Status',
                field: 'status',
                fpFieldType:"option",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "All", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    filterDropdownItems: ['Unverified','Active', 'Inactive'],
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Outstanding AR',
                field: 'outstanding_ar',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                type:'number',
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Outstanding AR", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        selectedArray:[],
        newList:true,
        loadselectedList:false,
        buttonText:'Add Customer',
        customer_error_msg:'',
        addedCustomer:[],
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_customer_discount') {
                        self.cantAccessPage = true;

                    }
                }
            }

        }

  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {
            self.loadCustomerDiscount();
        }else{
            self.loadList();
        }

        self.loadAddedCustomer();
  },
  methods: {
    cancelAll: function (cancelAll) {
      this.$refs.listDiscountCustomerTable.unselectAllInternal();
    },

    onSearchCustomer(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'customer', '');
        }
    },

    BackHeaderList() {
      var self = this;
      self.$router.push("/customer-discount/list");
    },

    CreateCustomerDiscount(flag) {
        var self = this;
        var error = false;

        self.name_error_msg = "";
        self.discount_error_msg = "";
        self.type_error_msg = '';
        self.customer_error_msg = '';

        if (self.name == null || self.name == '') {
            self.name_error_msg = "Name require.";
            error = true;
        }
        if (self.discount == null || self.discount == '' || self.discount == 0) {
            self.discount_error_msg = "Discount require.";
            error = true;
        }

        if (self.type == null || !self.type.value) {
            self.type_error_msg = "Type require.";
            error = true;
        }

        if (!self.selectedArray.length){
            self.customer_error_msg = 'Please select customer';
            error = true;
        }

        if (self.selectedArray && self.selectedArray.length > 0){
            for(var i=0;i<self.selectedArray.length;i++){
                if (self.addedCustomer.indexOf(self.selectedArray[i]) >= 0){
                    self.$swal('','Some customer are already added for another discount please deselect them','info');
                    return;
                }
            }
        }
        if (!error) {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createDiscountBtn").val("Updating ...");
                $("#createDiscountBtn").prop("disabled", true);
                $("#cancelDiscountBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueDiscountBtn").val("Saving ...");
                    $("#createDiscountBtn").prop("disabled", true);
                    $("#createAndContinueDiscountBtn").prop("disabled", true);
                    $("#cancelDiscountBtn").prop("disabled",true);

                }else{

                    $("#createDiscountBtn").val("Saving ...");
                    $("#createDiscountBtn").prop("disabled", true);
                    $("#createAndContinueDiscountBtn").prop("disabled", true);
                    $("#cancelDiscountBtn").prop("disabled",true);
                }

            }

            var fields = $("#DiscountForm").serializeArray();
            fields.push({name: "name", value: self.name});
            fields.push({name: "customer_id", value: JSON.stringify(self.selectedArray)});
            fields.push({name: "type", value: self.type.value});
            fields.push({name: "discount", value: self.removeFormat(self.discount)});

            if (segments[3]){
                fields.push({name: "id", value: segments[3]});
            }else{
                fields.push({name: "id", value:0});
            }
            $.ajax({
                url: process.env.ROOT_API + "/customer-discount/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        self.editContract = true;
                        $("#createDiscountBtn").val("Update");
                        $("#createDiscountBtn").prop("disabled", false);
                        $("#cancelDiscountBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueDiscountBtn").val("Save and Continue");
                            $("#createDiscountBtn").prop("disabled", false);
                            $("#createAndContinueDiscountBtn").prop("disabled", false);
                            $("#cancelDiscountBtn").prop("disabled",false);

                        }else{

                            $("#createDiscountBtn").val("Save");
                            $("#createDiscountBtn").prop("disabled", false);
                            $("#createAndContinueDiscountBtn").prop("disabled", false);
                            $("#cancelDiscountBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if ( flag == "Save and Continue") {

                            self.name = "";
                            self.type = "";
                            self.discount = "";
                            self.selectedArray = [];

                        } else {
                                self.BackHeaderList();
                        }

                    } else {
                        if (data.content.length > 0) {

                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createDiscountBtn").val("Update");
                        $("#createDiscountBtn").prop("disabled", false);
                        $("#cancelDiscountBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueDiscountBtn").val("Save and Continue");
                            $("#createDiscountBtn").prop("disabled", false);
                            $("#createAndContinueDiscountBtn").prop("disabled", false);
                            $("#cancelDiscountBtn").prop("disabled",false);

                        }else{

                            $("#createDiscountBtn").val("Save");
                            $("#createDiscountBtn").prop("disabled", false);
                            $("#createAndContinueDiscountBtn").prop("disabled", false);
                            $("#cancelDiscountBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,false,'contract-data-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }
    },

    loadCustomerDiscount() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/customer-discount/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {

                    self.name = data.content.name;
                    self.discount = data.content.discount;
                    self.type = {text:self.titleCase(data.content.type),value:data.content.type};
                    if(data.content.type == 'fixed') {
                      self.discount = self.amountFormat(data.content.discount);
                    }
                    self.newList = false;
                    self.loadselectedList = true;
                    self.selectedArray = data.content.customers;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'load-contract-data')
            }
        });
    },
    toggleList:function(){
        var self = this;
        if (self.newList){
            self.newList = false;
            self.loadselectedList = true;
            self.buttonText = 'Add Customer';

        }else{
            self.newList = true;
            self.loadselectedList = false;
            self.buttonText = 'Selected Customer';
            self.loadList();
        }
    },
    onPageChange(params) {
        var self = this;
        this.updateParams({page: params.currentPage});
        this.listCurrentPage = params.currentPage;

            this.loadList();
      },
      onRowClick(params){
           var self = this;
            setTimeout(function(){
                $('.vgt-selection-info-row').css({'display':'none'});
            },1);
                // self.selectedArray=[];
                if ($.inArray(params.row.id, self.selectedArray) != -1)
                {
                        // self.selectedArray.splice(i,1);
                    var index = self.selectedArray.indexOf(params.row.id);
                    if (index > -1) {
                        self.selectedArray.splice(index, 1);
                    }
                }else{
                    self.selectedArray.push(params.row.id);
                }
            // console.log("CustomerArr"+self.selectedArray);
      },
      selectionChanged(param) {
            var self = this;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
            // console.log(self.computed.selectedRows);
            // var rowData = self.$refs['my-table'].selectedRows;
            // console.log(rowData);
        },
      findElementIndex(array, attr, value) {
            for(var i = 0; i < array.length; i += 1) {
                if(array[i][attr] === value) {
                return i;
                }
            }
            return -1;
      },
      loadList() {

        var self = this;

        self.loading = true;
        //get selected customers ids

        var selectedRows = [];
            //because on first load list not initialize
            // var data = this.$refs['listCustomerTable'].selectedRows;
            // for ( var i = 0; i < data.length; i++ ) {
            //     selectedRows.push(this.$refs['listCustomerTable'].selectedRows[i].id)
            // }

        // self.dropDownPerPage=[];
        var fields = {

            page: self.serverParams.page,
            perPage: self.serverParams.perPage,
            filters: self.serverParams.columnFilters,
            sort: self.serverParams.sort,
            flag: self.flag,
            selectedRows:selectedRows,
            action:self.action,
            selectedAll:self.serverParams.selectedAll

        };

        self.firstLoad = 1;
        $.ajax({
            url: process.env.ROOT_API + "/customer/list",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;

                        for(var k=0;k< self.rows.length;k++){
                            if ($.inArray(self.rows[k].id, self.selectedArray) >= 0) {
                                    self.$set(self.rows[k], 'vgtSelected', true);
                                }
                        }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'customer-list-error')

            }
        });
    },
    loadAddedCustomer() {
        var self = this;
        var path = window.location.pathname;
        var segments = path.split("/");
        var addedId = 0;
        if (segments[3]){
            addedId = segments[3];
        }
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/added-customer/fetch",
            type: "GET",
            headers: this.ajxHeaders,
            data:{
                id:addedId
            },
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.addedCustomer = data.content;
                    // self.selectedArray = data.content.customers;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'load-added-customer');
            }
        });
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/CustomerDiscountCreate.vue